
import { get_group_link, getlink_sales_dept_id_user } from '@/api/apis'
import TUIChatEngine, {
    TUIGroupService,
    TUIUserService,
} from "@tencentcloud/chat-uikit-engine";
// 获取客户的群组关联 
export function getlink_group_id(origin_id: any) {
    return new Promise((resolve, reject) => {
        let obj = {
            origin_id:origin_id,
            source: 3,
        }
        get_group_link(obj).then(res => {
            console.log("获取群组link--", res)
            if (res.data.list && res.data.list.length > 0) {
                let gropuId = res.data.list[0].group_id;
                TUIGroupService.getGroupProfile({
                    groupID: gropuId,
                }).then(function (imResponse) {
                    console.log('成功获取到了群组', imResponse.data.group);
                    resolve(res.data.list[0].group_id);
                }).catch(function (imError) {
                    // console.warn('getGroupProfile error:', imError);
                    reject('error')
                });
            } else {
                reject('error');
            }
        }).catch(err => {
            reject('error');
            // console.warn('getGroupProfile error:', err);
        })
    })
}

// 获取销售区域下的关联人员列表
export function get_link_user_list(sales_dept_id: any) {
    return new Promise((resolve, reject) => {
        getlink_sales_dept_id_user({
            sales_dept_id: sales_dept_id
        }).then((res: any) => {
            console.log("获取用户列表----->", res)
            if (res.code = 200) {
                let list = res.data.list || [];
                resolve(list);
            }
        }).catch(err => {
            reject(err)
        })
    })

}

// 根据群组id 获取群组成员列表
export function getMmemberList(groupID: string) {
    return new Promise((resolve, reject) => {
        TUIGroupService.getGroupMemberList({
            groupID: groupID,
            offset:0,
            count:1000,
        }).then((resIm: any) => {
            console.log("resIm->", resIm)
            let tempArr: any[] = [];
            let member = resIm.data.memberList || [];
            if (member && member.length > 0) {
                console.log("群组中存在人")
                TUIUserService.getUserProfile({
                    userIDList: member.map((x: any) => x.userID),
                }).then((res) => {
                    tempArr = res.data;
                    tempArr.forEach((x: any) => {
                        x.name = x.userID;
                        let id_index = x.profileCustomField.findIndex(
                            (x: any) => x.key == "Tag_Profile_Custom_ID"
                        );
                        if (id_index != -1) {
                            x.id = x.profileCustomField[id_index].value;
                            x.value_show = x.name + "-" + x.profileCustomField[id_index].value;
                        }
                    });
                    console.log("tempArr")
                    resolve(tempArr)
                }).catch(err => {
                    reject(err)
                });
            }
        }).catch(error => {
            reject(error);
        })
    })
}

// 创建客户群组或普通群组 百林客
export function createCustomerGroup(groupTypeBlk: string, userList: Array<string>, groupName: string) {
    return new Promise((resolve, reject) => {
        console.log("userList->", userList,'groupname->',groupName)
        TUIUserService.getUserProfile({
            userIDList: userList
        }).then(res => {
            let canAddMembers: any = [];
            res.data.map((x: any) => {
                canAddMembers.push({
                    userID: x.userID,
                })
            })
            let name = res.data.map((x: any) => x.userID);
            if (name.length > 4) {
                name = name.slice(0, 4)
            }
            let name_ = groupName&&groupName!=''&&groupName!=undefined ? groupName : name.join(',');
            console.log("name->",name);
            let paramsObj:any = {
                name:name_,
                avatar: groupTypeBlk == 'normal' ? 'https://www.bio-cloud.com.cn:8022/icon/normal_group.png' : 'https://www.bio-cloud.com.cn:8022/icon/custom_group.png',
                type: TUIChatEngine.TYPES.GRP_PUBLIC,
                memberList: canAddMembers,
                inviteOption: TUIChatEngine.TYPES.INVITE_OPTIONS_FREE_ACCESS,
                groupCustomField: [{
                    key: 'IS_LINK',
                    value: 'true'
                }]
            }
            TUIGroupService.createGroup(paramsObj).then(resGroup => {
                resolve(resGroup)
            }).catch(err => {
                reject(err)
            })
        }).catch(error => {
            reject(error)
        })
    })
}
// 
export function createCustomerGroupFromSaleArea(groupTypeBlk: string, groupName: string, sales_dept_id: string | number) {
    return new Promise((resolve, reject) => {
        if (sales_dept_id) {
            // 如果传了销售区域，可以直接拿取销售区域下面的人员列表，若没有则拿传进来的用户列表
            get_link_user_list(sales_dept_id).then((list: any) => {
                console.log('获取的link销售区域下面的人员列表->', list);
                let user:Array<string> = [];
                list.map((x: any) => {
                    user.push(x.name)
                })
                createCustomerGroup(groupTypeBlk,user,groupName).then(resGroup=>{resolve(resGroup)})
            }).catch(err => {
                reject(err);
            });
        }
    })
}
